var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.776,
    height: 21.469,
    viewBox: "0 0 20.776 21.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in",
    transform: "translate(-6.75 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51803",
    "data-name": "Path 51803",
    d: "M26.985,6.75H16.6A1.846,1.846,0,0,0,14.75,8.6V22.909A1.846,1.846,0,0,0,16.6,24.756H26.985Z",
    transform: "translate(-0.613 -0.057)",
    fill: "#f3f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51804",
    "data-name": "Path 51804",
    d: "M16.828,22.909V8.6A1.846,1.846,0,0,1,18.674,6.75H16.6A1.846,1.846,0,0,0,14.75,8.6V22.909A1.846,1.846,0,0,0,16.6,24.756h2.078A1.846,1.846,0,0,1,16.828,22.909Z",
    transform: "translate(-0.613 -0.057)",
    fill: "#d5dbe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51811",
    "data-name": "Path 51811",
    d: "M6.75,15.75h8.772v1.385H6.75Z",
    transform: "translate(0 -0.747)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51812",
    "data-name": "Path 51812",
    d: "M12.949,20.124l-.979-.979,2.973-2.973L11.97,13.2l.98-.98,3.463,3.463a.693.693,0,0,1,0,.98Z",
    transform: "translate(-0.4 -0.476)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51814",
    "data-name": "Path 51814",
    d: "M15.385,9.924H14V8.539A2.541,2.541,0,0,1,16.539,6H26.928V7.385H16.539a1.156,1.156,0,0,0-1.154,1.154Z",
    transform: "translate(-0.555 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51815",
    "data-name": "Path 51815",
    d: "M20.233,26.674H16.539A2.541,2.541,0,0,1,14,24.135V22.75h1.385v1.385a1.156,1.156,0,0,0,1.154,1.154h3.694Z",
    transform: "translate(-0.555 -1.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51805",
    "data-name": "Path 51805",
    d: "M20.75,9.851V27.026A1.174,1.174,0,0,0,21.9,28.219a1.2,1.2,0,0,0,.369-.057l5.54-1.908a1.206,1.206,0,0,0,.785-1.135V7.943A1.174,1.174,0,0,0,27.445,6.75a1.2,1.2,0,0,0-.369.057l-5.54,1.908A1.206,1.206,0,0,0,20.75,9.851Z",
    transform: "translate(-1.072 -0.75)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51806",
    "data-name": "Path 51806",
    d: "M22.828,26.788V9.613a1.206,1.206,0,0,1,.785-1.135L28.046,6.95a1.089,1.089,0,0,0-.6-.2,1.2,1.2,0,0,0-.369.057l-5.54,1.908a1.206,1.206,0,0,0-.785,1.135V27.026A1.174,1.174,0,0,0,21.9,28.219a1.2,1.2,0,0,0,.369-.057l1.107-.382A1.18,1.18,0,0,1,22.828,26.788Z",
    transform: "translate(-1.072 -0.75)",
    fill: "#b9353e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.b317091a8e174d250377405fff845700.svg";
export { ForwardRef as ReactComponent };